// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__27Q3-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__26W23","obliqueLine":"membershipbadge_obliqueLine__10Uwi"};